import { makeContextModule } from '@cian/react-utils';

export interface IMapStoreContext {
  ymaps: YMaps.IYMaps;
  map: YMaps.Map;
}

export const { Context: MapStoreContext, useContext: useMapStoreContext } = makeContextModule<IMapStoreContext>({
  contextName: 'MapStoreContext',
});
